import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { unarchiveSession } from "@/utils/multi-session";

export function useUnarchiveSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (sessionId: string) => {
      const ok = await unarchiveSession(sessionId);
      if (!ok) {
        throw new Error("Failed to unarchive session");
      }
      return sessionId;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.formSessions.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.sessions.all });
    },
  });
}
